module.exports = __webpack_public_path__ + "static/img/插秧机.4f366a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/智能碰撞预警系统/插秧机.png
// module id = r14i
// module chunks = 0